import script from "./MyWallet.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyWallet.vue?vue&type=script&setup=true&lang=ts"

import "./MyWallet.vue?vue&type=style&index=0&id=3168df8a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3168df8a"]])

export default __exports__